import type { ComponentType, SVGProps } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { routes } from "@/app/navigation/routes";
import {
  CreditCardIcon,
  GavelIcon,
  GearIcon,
  LogoutIcon,
  MessageCircleIcon,
  TrophyIcon,
  UserIcon,
} from "@/assets/svg";
import styles from "./SettingsLayout.module.css";

type SettingsNavItem = {
  label: string;
  to: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

const accountSection: SettingsNavItem[] = [
  { label: "Account", to: routes.settingsAccount, icon: UserIcon },
  // { label: "Home", to: routes.settingsHome, icon: HomeIcon },
  // { label: "Properties", to: routes.settingsProperties, icon: PropertiesIcon },
];

const othersSection: SettingsNavItem[] = [
  { label: "Protest History", to: routes.settingsProtestHistory, icon: GavelIcon },
  { label: "Autopay Subscription", to: routes.settingsAutopaySubscription, icon: CreditCardIcon },
  {
    label: "Historical Achievements",
    to: routes.settingsHistoricalAchievements,
    icon: TrophyIcon,
  },
  { label: "App Settings", to: routes.settingsAppSettings, icon: GearIcon },
  { label: "Contact Us", to: routes.settingsContactUs, icon: MessageCircleIcon },
  { label: "Logout", to: routes.settingsLogout, icon: LogoutIcon },
];

const renderNavItem = (item: SettingsNavItem) => {
  const Icon = item.icon;

  return (
    <NavLink
      key={item.to}
      to={item.to}
      className={({ isActive }) =>
        `${styles.navItem} ${isActive ? styles.activeNavItem : ""}`.trim()
      }
    >
      <Icon className={styles.navIcon} aria-hidden="true" />
      <span>{item.label}</span>
    </NavLink>
  );
};

export const SettingsLayout = () => {
  return (
    <div className={styles.settingsPage}>
      <div className={styles.settingsShell}>
        <aside className={styles.sidebar}>
          <h2 className={styles.sidebarTitle}>Account Settings</h2>

          <div className={styles.sectionLabel}>Account Settings</div>
          <nav className={styles.navList}>{accountSection.map(renderNavItem)}</nav>

          <div className={styles.sectionLabel}>Others</div>
          <nav className={styles.navList}>{othersSection.map(renderNavItem)}</nav>
        </aside>

        <section className={styles.content}>
          <Outlet />
        </section>
      </div>
    </div>
  );
};
